var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66668 0.333333V6.39067L7.95964 5.0977C8.08982 4.96753 8.30087 4.96753 8.43105 5.0977L8.90231 5.56896C9.03248 5.69914 9.03248 5.91019 8.90231 6.04037L6.23571 8.70696C6.10554 8.83714 5.89448 8.83714 5.76431 8.70696L3.09771 6.04037C2.96754 5.91019 2.96754 5.69914 3.09771 5.56896L3.56897 5.0977C3.69915 4.96753 3.9102 4.96753 4.04038 5.0977L5.33334 6.39067V0.333333C5.33334 0.149238 5.48258 0 5.66668 0H6.33334C6.51744 0 6.66668 0.149239 6.66668 0.333333Z",
    fill: "#567AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 8C0.149238 8 0 8.14924 0 8.33333V11.3333C0 11.7015 0.298477 12 0.666667 12H11.3333C11.7015 12 12 11.7015 12 11.3333V8.33333C12 8.14924 11.8508 8 11.6667 8H11C10.8159 8 10.6667 8.14924 10.6667 8.33333V10.6667H1.33333V8.33333C1.33333 8.14924 1.18409 8 1 8H0.333333Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.61d71caa.svg";
export { ForwardRef as ReactComponent };